import { InjectionToken } from '@angular/core';

export const GRAPH_CMS_TOKEN = new InjectionToken<string>('GRAPH_CMS_TOKEN');
